import { createFileRoute, redirect } from '@tanstack/react-router';

// Entrada del drill-down: /platform/tenants/$tenantId redirige a la pestaña Usuarios (primer recurso
// del sub-nav). El guard de scope PLATFORM ya aplicó en el layout padre.
export const Route = createFileRoute('/_authenticated/_layout/platform/tenants/$tenantId/')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/platform/tenants/$tenantId/users',
            params: { tenantId: params.tenantId },
        });
    },
});
